<div class="w-full flex flex-row items-center gap-4">
  <button (click)="onSubmit()"
          [disabled]="isSubmittingPhase"
          class="btn btn-primary flex flex-row gap-2 items-center min-w-[3rem]"
          style="border-radius: 0.5rem;padding: 0.5rem 1rem">
    <img alt="Icon" class="filter-neutral-100 h-4" src="/assets/icons/feather/save.svg">
    <span class="hidden lg:block cd-text-md truncate">Continuar</span>
  </button>
</div>

<div class="grid grid-cols-1 lg:grid-cols-5 gap-4">
  <div class="lg:col-span-3 flex flex-col gap-5">
    <div class="rounded-2xl bg-neutral-100 p-6">
      <h3 class="mb-4 text-[1.25rem]">Encuestas relanzadas</h3>
      <core-table
        [data]="surveys"
        [expandableTemplate]="surveyInfoTmpl"
        [headers]="[
          { label: 'Encuesta', customTemplate: surveyNameTmpl},
          { label: 'Nº Preguntas', field: 'questionsCount', options: {align: 'center', verticalAlign: 'middle'}},
          { label: 'Empleados asociados', field: 'employeesCount', options: {align: 'center', verticalAlign: 'middle'}},
          { label: 'Progreso respuestas', customTemplate: surveyProgressTmpl, options: {align: 'center', verticalAlign: 'middle'}}
        ]"
      />
    </div>

    <div class="rounded-2xl bg-neutral-100 p-6">
      <h3 class="mb-4 text-[1.25rem]">Declaraciones modificadas</h3>
      <core-table
        [data]="declarations"
        [headers]="[
          { label: 'Declaración', field: 'name'},
          { label: 'Variable', field: 'variableName', options: { verticalAlign: 'middle' }},
          { label: 'Valor declarado', customTemplate: declarationValueTmpl, options: { verticalAlign: 'middle' }}
        ]"
      />
    </div>
  </div>

  <div class="lg:col-span-2 rounded-2xl bg-neutral-100 flex flex-col gap-5 p-6">
    <h3 class="text-[1.25rem]">Riesgo inherente congelado</h3>
    <core-table
      [data]="frozenRiskSnapshot"
      [headers]="[
        { label: 'Concepto de riesgo', field: 'concept'},
        { label: 'Riesgo', customTemplate: frozenRiskTmpl}
      ]"
    />

    <h3 class="text-[1.25rem]">Evolución del inherente (actualizado)</h3>
    <core-table
      [data]="riskComparison"
      [headers]="[
        { label: 'Concepto de riesgo', field: 'concept'},
        { label: 'Riesgo', customTemplate: currentRiskTmpl}
      ]"
    />
  </div>
</div>

<ng-template #surveyNameTmpl let-item>
  <div class="flex flex-col py-2 pl-2 pr-4">
    <span class="cd-text-b1 text-neutral-800">{{ item.name }}</span>
    @if (item.description) {
      <span class="cd-text-b4 font-semibold text-neutral-500">{{ item.description }}</span>
    }
  </div>
</ng-template>

<ng-template #surveyInfoTmpl let-item>
  <div class="w-full p-4 flex flex-col gap-2 border-1 rounded-lg mt-2" style="border-color: var(--color-neutral-400)">
    <core-table
      [data]="surveyQuestions(item)"
      [headers]="[
        { label: 'Pregunta', field: 'text'},
        { label: 'Tipo', field: 'type', options: { verticalAlign: 'middle' }}
      ]"
    />
  </div>
</ng-template>

<ng-template #declarationValueTmpl let-item>
  <span class="cd-text-b2 text-neutral-900">
    {{ item.declaredValue || item.threshold || (item.booleanAnswer === 'no' ? 'No' : 'Sí') }}
  </span>
</ng-template>

<ng-template #surveyProgressTmpl let-item>
  <div class="flex flex-row w-full relative items-center gap-3">
    <div class="w-full bg-neutral-300 h-2 rounded-[0.75rem] relative min-w-[6rem]">
      <div class="bg-primary-600 absolute rounded-[0.75rem] h-2 top-0 left-0"
           [style.width]="((item.employeesCount || 0) > 0 ? ((item.completedCount || 0) / (item.employeesCount || 1) * 100) : 0).toFixed(0) + '%'"></div>
    </div>
    <span class="cd-text-b3 cd-text-mono whitespace-nowrap">
      {{ item.completedCount || 0 }} / {{ item.employeesCount || 0 }}
    </span>
  </div>
</ng-template>

<ng-template #frozenRiskTmpl let-item>
  <div class="flex flex-row w-full relative items-center gap-3">
    <div class="w-full bg-neutral-300 h-2 rounded-[0.75rem] relative">
      <div [class.bg-green-300]="item.current >= 75"
           [class.bg-red-300]="item.current < 50"
           [class.bg-yellow-300]="item.current >= 50 && item.current < 75"
           [style.width]="item.current.toFixed(0) + '%'"
           class="absolute rounded-[0.75rem] h-2 top-0 left-0"></div>
    </div>
    <span class="cd-text-b3 cd-text-mono whitespace-nowrap">{{ item.current.toFixed(0) + '%' }}</span>
  </div>
</ng-template>

<ng-template #currentRiskTmpl let-item>
  <div class="flex flex-row w-full relative items-center gap-3">
    <div class="w-full bg-neutral-300 h-2 rounded-[0.75rem] relative">
      <div [class.bg-green-300]="item.current >= 75"
           [class.bg-red-300]="item.current < 50"
           [class.bg-yellow-300]="item.current >= 50 && item.current < 75"
           [style.width]="item.current.toFixed(0) + '%'"
           class="absolute rounded-[0.75rem] h-2 top-0 left-0"></div>
    </div>
    <span class="cd-text-b3 cd-text-mono whitespace-nowrap">{{ item.current.toFixed(0) + '%' }}</span>
  </div>
</ng-template>
